<template>
    <div class="row pt-5" :class="campaign_uuid ? 'p-5' : ''">
        <div class="col-12">
            <span v-if="!editMode">
                <h4 class="campaing-name" @dblclick="openEditMode">{{ model.name }}</h4>
                <button @click="openEditMode()" style="color: #7d2dbd">{{ $t('marketing.campaigns.edit_name') }}</button>
            </span>
            <div v-else>
                <div class="row">
                    <div class="col-11">
                        <input class="form-control" type="text" v-model="model.name" @keyup.enter="openEditMode" />
                    </div>
                    <div class="col-1">
                        <button class="btn fs-xs btn-primary-icon px-4 rounded-8 fw-medium" v-on:click="openEditMode">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M17 21V13H7V21"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M7 3V8H15"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-9 col-md-12" style="position: relative">
            <div class="loader-overlay" v-if="isLoadingSendBtn"></div>
            <!-- Step 1 -->
            <div class="collaps">
                <div class="collaps-title row">
                    <div class="col-lg-1 col-md-1 col-sm-1 icon">
                        <i
                            class="fa fa-check-circle fa-3"
                            :class="isStepValid(0) ? 'fa-success' : 'fa-default'"
                            aria-hidden="true"
                        ></i>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-11">
                        <h3 class="collaps-subtitle">A</h3>
                        <p class="collaps-description">
                            <span v-if="!isStepValid(0)">{{ $t('marketing.campaigns.step_recipients') }}</span>
                            <span v-else>{{ model.selectedFilter.display_name }}</span>
                        </p>
                    </div>
                    <div
                        class="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center d-flex justify-content-center"
                        v-show="!blocks[0].isOpen"
                    >
                        <button
                            class="btn btn-primary fs-xs btn-plr-15 fw-medium rounded-8 h-40 mt-1 text-nowrap"
                            style="float: inline-end"
                            @click="toggle(0)"
                        >
                            {{ $t('marketing.campaigns.add_recipients') }}
                        </button>
                    </div>
                </div>

                <div name="expand" @enter="enter" @leave="leave">
                    <div v-show="blocks[0].isOpen" class="collaps-content">
                        <div class="row mt-3">
                            <div class="col-1"></div>

                            <div class="col-11">
                                <div class="row">
                                    <div class="col-12 col-lg-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="compaing_email_select_filter" class="form-label">{{
                                                $t('marketing.campaigns.send_to')
                                            }}</label>
                                            <button @click="openModalCustomerFilters" class="text-muted float-right">
                                                {{ $t('marketing.campaigns.add_filters') }}
                                            </button>
                                            <v-select
                                                class="v-select"
                                                id="compaing_email_select_filter"
                                                :options="applyedFiltersList"
                                                v-model="model.selectedFilter"
                                                label="display_name"
                                                :placeholder="$t('marketing.campaigns.customer_list')"
                                                hide-selected
                                                @input="setSelectedFilter"
                                                :get-option-label="(option) => option.display_name"
                                            >
                                                <template #option="{ display_name }">
                                                    {{ display_name }}
                                                </template>
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        {{ $t('marketing.campaigns.no_results_for') }} <em>{{ search }}</em
                                                        >.
                                                    </template>
                                                    <em v-else style="opacity: 0.5">{{
                                                        $t('marketing.campaigns.no_element_found')
                                                    }}</em>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="col-12 col-lg-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="exclude_emails" class="form-label">{{
                                                $t('marketing.campaigns.do_not_send_to')
                                            }}</label>
                                            <button @click="remove" class="text-muted float-right">
                                                {{ $t('marketing.campaigns.remove_emails') }}
                                            </button>
                                            <v-select
                                                ref="compaing_email_select_filter_ref"
                                                class="v-select"
                                                id="exclude_emails"
                                                :options="customers"
                                                v-model="model.exclude_emails"
                                                label="email"
                                                :placeholder="'emails'"
                                                hide-selected
                                                :filterable="true"
                                                :clearable="true"
                                                multiple
                                                @search="onSearch"
                                            >
                                                <template #option="{ first_name, last_name, email }">
                                                    {{ first_name }} {{ last_name }} <br />
                                                    <small
                                                        ><em>{{ email }}</em></small
                                                    >
                                                </template>
                                                <template v-slot:no-options="{ search, searching }">
                                                    <template v-if="searching">
                                                        {{ $t('marketing.campaigns.no_results_for') }} <em>{{ search }}</em
                                                        >.
                                                    </template>
                                                    <em v-else style="opacity: 0.5">{{
                                                        $t('marketing.campaigns.no_user_found')
                                                    }}</em>
                                                </template>
                                                <!-- <template #list-footer>
                                                    <li v-show="hasNextPage" ref="loadMoreRef" class="loader"> </li>
                                                </template> -->
                                            </v-select>
                                        </div>
                                    </div>
                                </div>
                                <div class="btns mt-3" v-show="blocks[0].isOpen">
                                    <button
                                        :disabled="!isStepValid(0)"
                                        class="btn btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                                        @click="save(0)"
                                    >
                                        {{ $t('common.save') }}
                                    </button>
                                    <button
                                        class="btn btn-primary-inverse btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                                        @click="toggle(0)"
                                    >
                                        {{ $t('common.cancel') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 2 -->
            <div class="collaps">
                <div class="collaps-title row">
                    <div class="col-lg-1 col-md-1 col-sm-1 icon">
                        <i
                            class="fa fa-check-circle fa-3"
                            :class="isStepValid(1) ? 'fa-success' : 'fa-default'"
                            aria-hidden="true"
                        ></i>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-11">
                        <h3 class="collaps-subtitle">{{ $t('marketing.campaigns.from') }}</h3>
                        <p class="collaps-description">
                            <span v-if="!isStepValid(1)">{{ $t('marketing.campaigns.who_sends') }}</span>
                            <span v-else>{{ model?.name_sender + ', ' + model?.email_sender }}</span>
                        </p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center" v-show="!blocks[1].isOpen">
                        <button
                            class="btn btn-primary fs-xs btn-plr-15 fw-medium rounded-8 h-40 mt-1 text-nowrap"
                            style="float: inline-end"
                            @click="toggle(1)"
                        >
                            {{ $t('marketing.campaigns.add_sender') }}
                        </button>
                    </div>
                </div>

                <div name="expand" @enter="enter" @leave="leave">
                    <div v-show="blocks[1].isOpen" class="collaps-content">
                        <div class="row mt-3">
                            <div class="col-1"></div>

                            <div class="col-11">
                                <div class="row">
                                    <div class="col-12 col-lg-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="name_sender" class="form-label">{{
                                                $t('marketing.campaigns.instance_name')
                                            }}</label>
                                            <span class="text-muted float-right">{{ $t('marketing.campaigns.required') }}</span>
                                            <input
                                                v-model="model.name_sender"
                                                id="name_sender"
                                                class="form-control"
                                                :placeholder="$t('marketing.campaigns.instance_name')"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div class="col-12 col-lg-6 col-xs-12">
                                        <div class="form-group">
                                            <label for="email_sender" class="form-label">{{
                                                $t('marketing.campaigns.marketing_email')
                                            }}</label>
                                            <span class="text-muted float-right">{{ $t('marketing.campaigns.required') }}</span>
                                            <input
                                                v-model="model.email_sender"
                                                id="email_sender"
                                                class="form-control"
                                                :placeholder="$t('marketing.campaigns.marketing_email')"
                                                type="email"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="btns mt-3" v-show="blocks[1].isOpen">
                                    <button
                                        class="btn btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                                        :disabled="isValideStep2"
                                        @click="save(1)"
                                    >
                                        {{ $t('common.save') }}
                                    </button>
                                    <button
                                        class="btn btn-primary-inverse btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                                        @click="toggle(1)"
                                    >
                                        {{ $t('common.cancel') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 3 -->
            <div class="collaps">
                <div class="collaps-title row">
                    <div class="col-lg-1 col-md-1 col-sm-1 icon">
                        <i
                            class="fa fa-check-circle fa-3"
                            :class="isStepValid(2) ? 'fa-success' : 'fa-default'"
                            aria-hidden="true"
                        ></i>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-11">
                        <h3 class="collaps-subtitle">{{ $t('marketing.campaigns.subject') }}</h3>
                        <p class="collaps-description">
                            <span v-if="model?.email_subject === ''">{{ $t('marketing.campaigns.which_subject') }}</span>
                            <span v-else>{{ model?.email_subject }}</span>
                        </p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center" v-show="!blocks[2].isOpen">
                        <button
                            class="btn btn-primary fs-xs btn-plr-15 fw-medium rounded-8 h-40 mt-1 text-nowrap"
                            style="float: inline-end"
                            @click="toggle(2)"
                        >
                            {{ $t('marketing.campaigns.add_subject') }}
                        </button>
                    </div>
                </div>

                <div name="expand" @enter="enter" @leave="leave">
                    <div v-show="blocks[2].isOpen" class="collaps-content">
                        <div class="row mt-3">
                            <div class="col-1"></div>

                            <div class="col-11">
                                <div class="row">
                                    <div class="col-lg-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="email_subject" class="form-label">{{
                                                $t('marketing.campaigns.subject')
                                            }}</label>
                                            <input
                                                v-model="model.email_subject"
                                                id="email_subject"
                                                class="form-control"
                                                :placeholder="$t('marketing.campaigns.subject')"
                                                required
                                            />
                                        </div>
                                        <div class="mt-2">
                                            {{ $t('marketing.campaigns.subject_tip') }}
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-xs-12">
                                        <div class="form-group">
                                            <label for="email_subject_preview" class="form-label">{{
                                                $t('marketing.campaigns.preview_text')
                                            }}</label>
                                            <input
                                                v-model="model.email_subject_preview"
                                                id="email_subject_preview"
                                                class="form-control"
                                                :placeholder="$t('marketing.campaigns.preview_text')"
                                                required
                                            />
                                        </div>
                                        <div class="mt-2">
                                            {{ $t('marketing.campaigns.preview_text_tip') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="btns mt-3" v-show="blocks[2].isOpen">
                                    <button
                                        class="btn btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                                        @click="save(2)"
                                    >
                                        {{ $t('common.save') }}
                                    </button>
                                    <button
                                        class="btn btn-primary-inverse btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                                        @click="toggle(2)"
                                    >
                                        {{ $t('common.cancel') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 4 -->
            <div class="collaps">
                <div class="collaps-title row">
                    <div class="col-lg-1 col-md-1 col-sm-1 icon">
                        <i
                            class="fa fa-check-circle fa-3"
                            :class="isStepValid(3) ? 'fa-success' : 'fa-default'"
                            aria-hidden="true"
                        ></i>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-11">
                        <h3 class="collaps-subtitle">{{ $t('marketing.campaigns.step_time') }}</h3>
                        <p class="collaps-description">
                            <span v-if="!isStepValid(3)">{{ $t('marketing.campaigns.when_to_send') }}</span>
                            <span v-else>
                                <span v-if="model.selectedOption === 'send-now'">{{
                                    $t('marketing.campaigns.send_now_label')
                                }}</span>
                                <span v-if="model.selectedOption === 'send-prog'">
                                    {{ model.start_date ? formatDate(model.start_date) : 'DD/MM/YYYY' }},
                                    {{ model.start_time ? extractTime(model.start_time) : 'HH:mm' }}
                                </span>
                            </span>
                        </p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center" v-show="!blocks[3].isOpen">
                        <button
                            class="btn btn-primary fs-xs btn-plr-15 fw-medium rounded-8 h-40 mt-1 text-nowrap"
                            style="float: inline-end"
                            @click="toggle(3)"
                        >
                            {{ $t('marketing.campaigns.modify_send_time') }}
                        </button>
                    </div>
                </div>

                <div name="expand" @enter="enter" @leave="leave">
                    <div v-show="blocks[3].isOpen" class="collaps-content">
                        <div class="row mt-3">
                            <div class="col-1"></div>

                            <div class="col-11">
                                <div class="row">
                                    <div class="col-12 col-lg-6 col-xs-12">
                                        <div
                                            class="radio-container"
                                            :class="{ 'selected-container': model.selectedOption === 'send-prog' }"
                                            @click="selectOption('send-prog')"
                                        >
                                            <input
                                                type="radio"
                                                id="send-prog"
                                                name="radio-group"
                                                v-model="model.selectedOption"
                                                value="send-prog"
                                                class="custom-radio"
                                            />
                                            <label for="send-prog">{{ $t('marketing.campaigns.send_prog_label') }}</label>
                                            <p class="text-muted radio-description">
                                                {{ $t('marketing.campaigns.optimize_timing') }}
                                            </p>
                                        </div>
                                    </div>

                                    <div class="col-12 col-lg-6 col-xs-12">
                                        <div
                                            class="radio-container"
                                            :class="{ 'selected-container': model.selectedOption === 'send-now' }"
                                            @click="selectOption('send-now')"
                                        >
                                            <input
                                                type="radio"
                                                id="send-now"
                                                name="radio-group"
                                                v-model="model.selectedOption"
                                                value="send-now"
                                                class="custom-radio"
                                            />
                                            <label for="send-now">{{ $t('marketing.campaigns.send_now_label') }}</label>
                                            <p class="text-muted radio-description">
                                                {{ $t('marketing.campaigns.make_email_reach_now') }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="model.selectedOption === 'send-prog'">
                                    <div class="col-lg-6 col-xs-12">
                                        <label id="start_date" class="form-label mt-2">{{
                                            $t('marketing.campaigns.send_date')
                                        }}</label>
                                        <div>
                                            <date-picker
                                                v-model="model.start_date"
                                                format="DD/MM/YYYY"
                                                type="date"
                                                :placeholder="$t('resource_planning.weekRangeScheduling.period_date_placeholder')"
                                                :default-value="new Date()"
                                                :disabled-date="notBeforeToday"
                                                :disabled-time="notBeforeTodayTwelveOClock"
                                            ></date-picker>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-xs-12">
                                        <label id="start_time" class="form-label mt-2">{{
                                            $t('marketing.campaigns.step_time')
                                        }}</label>
                                        <div>
                                            <date-picker
                                                v-model="model.start_time"
                                                format="HH:mm"
                                                type="time"
                                                placeholder="HH:mm"
                                                :default-value="new Date().setHours(12, 0, 0, 0)"
                                            ></date-picker>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="btns mt-3"
                                    :class="{ 'mt-8': model.selectedOption != 'send-prog' }"
                                    v-show="blocks[3].isOpen"
                                >
                                    <button
                                        class="btn btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                                        @click="save(3)"
                                    >
                                        {{ $t('common.save') }}
                                    </button>
                                    <button
                                        class="btn btn-primary-inverse btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                                        @click="toggle(3)"
                                    >
                                        {{ $t('common.cancel') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Step 5 -->
            <div class="collaps">
                <div class="collaps-title row">
                    <div class="col-lg-1 col-md-1 col-sm-1 icon">
                        <i
                            class="fa fa-check-circle fa-3"
                            :class="isStepValid(4) ? 'fa-success' : 'fa-default'"
                            aria-hidden="true"
                        ></i>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-11">
                        <h3 class="collaps-subtitle">{{ $t('marketing.campaigns.step_content') }}</h3>
                        <p class="collaps-description">{{ $t('marketing.campaigns.design_content') }}</p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center" v-show="!blocks[4].isOpen">
                        <button
                            class="btn btn-primary fs-xs btn-plr-15 fw-medium rounded-8 h-40 mt-1 text-nowrap"
                            style="float: inline-end"
                            @click="toggle(4)"
                        >
                            {{ $t('marketing.campaigns.create_email') }}
                        </button>
                    </div>
                </div>

                <div name="expand" @enter="enter" @leave="leave">
                    <div v-show="blocks[4].isOpen" class="collaps-content">
                        <div class="row mt-3">
                            <div class="col-1"></div>

                            <div class="col-11">
                                <div class="btns mt-3" v-show="blocks[4].isOpen">
                                    <!-- <button class="btn btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1">
                                        Concevez votre email
                                    </button> -->
                                    <button
                                        class="btn btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1"
                                        @click="goToModels()"
                                        :disabled="model.uuid === ''"
                                    >
                                        {{ $t('marketing.campaigns.choose_ready_email') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-md-12">
            <div v-if="model.content">
                <div
                    v-html="model.content"
                    :style="{ width: '100%', maxHeight: '500px', overflow: 'auto', boxSizing: 'border-box' }"
                    @click="exportHtmlAndOpenModal"
                ></div>
            </div>
            <img
                v-else
                class="compaine-img-block"
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAACWCAYAAAAVKkwgAAAFjElEQVR4Ae2dv24kRRDGDTr+iL+HEIEDhMgAESAhRISQLrz0HoFXIORVCAl5BXQRISkZXTNrry1bNqEva1Ri66Y8Wp9V3qSr9Dup1bWy9lTf9/XX1dMzvXMkIp1Wl4MjxK0rrmqLwMVnMARG4NpTWPUShYNxMA7O7PK1g29aa89peTkQkRs/INcC/3PEv9QMiEhD4NQSvjp5BH41P+n/GhJYRI5F5Cfa0Bwc+1EZFfiJn8+Jh7yieILAta91Ebj4zIPACLxMYbeug0WEGrxwM+p9cxyMg5dRioMXLkZ17DovHIyDl1GLgxcu1k4Z9TMOxsHLqMXBCxejOnadFw7GwcuoxcELF2unjPoZB+PgZdTi4IWLUR27zgsH4+Bl1OLghYu1U0b9jINx8DJqbzl4s9n82Fp7QRuXA9XowU90+C8S52Ag9ExWDkhk6RlAYM9GwRiBC4rqISGwZ6NgjMAFRfWQENizUTAOCXxycvKxiDyt0Hrvj0xPjStgUgyqkeHSPiRwpcdmp2n6yIjQuNDuFluVKiYC/79deWurEgcPedhsfdMDB+PgO2424GAcvJ4uhv1MDaYGDzs471nxU4OpwdTgrO7VvHEwDsbBOPieQj88QayiWUUPP0jvMBk1mBpMDc7qXs0bB+NgHIyD7yjwaYhhFc0qOs1gXZmNGkwNpgZnda/mjYNxMA7GwavCno4QVtGsotMN2p3pqMHUYGpwVvdq3jgYB9/h4NbaNyLyR4V2cXHxnp1N0rgCJsWgGhmu8OEz/0XiHAyEThfmgESWngEE9mwUjBG4oKgeEgJ7NgrGCFxQVA8pJPB2u/1MRH6p0FprbxsRGlfApBhUI8OlfUhg3SXJfpPB8udmw56bDaenp5+KyM8VWu/9LRvpGlfApBhUI8MVdrD/InEOBkJTdA5IZOkZCAk8TdNXIvJbhbbdbt8xIjSugEkxqEaGS/uQwCyyiv8ICz9lOP7POB70U4be+sQ5GAhN0TkgkaVnICTwPM/fichfFdrl5eX7RoTGFTApBtXIcGkfEphFVvFF1m7P9nMRSd9676/bSNe4AibF4PfYww42QujzMBCaovPAIlNjICRwsVfbPTYSWmuPq7yu76BX2yHwuO8stAF6kMA24unzMBCaovPAIlNjICQwl0njXx4edJnERkfxjQ62Ksffpj1oq9Lmdfo8DIRqcB5YZGoMhATmhn/xG/4ssoovsnjobvwHDg966M7mdfo8DIRqcB5YZGoMhATm6Mr4x3YOOrrCIqv4Iovjo+MfnT3o+KjN6/R5GAjV4DywyNQYCAncWvtCRH6t0PYcPiuBSzUycbUPCcwiq/gi6+zs7BMReVah9d7fsJGucQVMikE1MlxhB/svEudgIDRF54BElp6BkMDTNH0rIn9WaHsOn5XApRo9WGAWWcUXWbvfsvhSRNK3PYfP0mNSXfzlnzo5NEV76xPnYACBc+j04CxDAs/z/IOI/FuhXV9ff2isaVwBk2JQjQyX9iGBWWQVX2T5kUGcg4GQg3NAIkvPQEjg3vubInJcofXeXzMiNK6ASTGoRoZL+5DA1ODiNXiz2XwvIn9XaFdXVx/YSNe4AibFoBoZrrCD/ReJczAQmqJzQCJLz0BIYH3Pwa4O67sbUrfe+yMjQuPseCx//y4KxRcSePefZH716svcPRG7gfvyb/bijqT9w18vO8/z1yLye4V2fn7+rjlY4wqYFINqZLjCDvZfJM7BQGiKzgGJLD0DCOzZKBgjcEFRPSQE9mwUjBG4oKgeEgJ7NgrGCFxQVA8JgT0bBWMELiiqh4TAno2CMQIXFNVDQmDPRsEYgQuK6iEhsGejYIzABUX1kO4T+Ka19pyWlwMRufFPpugzPFUeXQHHHi0ReA8plQY9AhcX+D9yUAptnCOmNgAAAABJRU5ErkJggg=="
            />
        </div>

        <div class="col-12">
            <button
                v-if="shouldDisplayButtonFinishLater"
                class="campaing-name m-4"
                style="color: #7d2dbd"
                @click="campaigneEmailstore('end')"
            >
                <span v-if="isLoadingSaveBtn">
                    <i class="fa fa-spinner fa-spin fa-fw"></i> {{ $t('common.loading') }}
                    <span class="sr-only"> {{ $t('common.loading') }}</span>
                </span>
                <span v-else> {{ $t('marketing.campaigns.finish_later') }}</span>
            </button>

            <button
                v-if="shouldDisplayButtonFinishLater"
                class="btn btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1 m-4"
                :disabled="isLoadingSendTestBtn || model.uuid === ''"
                @click="exportHtmlAndOpenModal"
            >
                <span v-if="isLoadingSendTestBtn">
                    <i class="fa fa-spinner fa-spin fa-fw"></i> {{ $t('common.loading') }}
                    <span class="sr-only"> {{ $t('common.loading') }}</span>
                </span>
                <span v-else>
                    <i class="fas fa-check" :title="$t('marketing.campaigns.send_test')"></i>
                    {{ $t('marketing.campaigns.send_test') }}</span
                >
            </button>

            <button
                v-if="shouldDisplayButtonFinishLater"
                class="btn btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-40 mt-1 m-4"
                :disabled="isLoadingSendBtn || model.uuid === '' || model.status != 0"
                @click="send()"
            >
                <span v-if="isLoadingSendBtn">
                    <i class="fa fa-spinner fa-spin fa-fw"></i> {{ $t('common.loading') }}
                    <span class="sr-only"> {{ $t('common.loading') }}</span>
                </span>
                <span v-else>
                    <i class="fas fa-check" :title="$t('marketing.campaigns.send')"></i>
                    {{ $t('marketing.campaigns.send') }}</span
                >
            </button>

            <div class="switch-container mt-1">
                <span class="input-with-icon">
                    <label class="campaign-email-switch">
                        <input
                            v-model="model.security_user_received_last_hour_is_active"
                            type="checkbox"
                            @click="campaigneEmailstore()"
                        />
                        <div class="checkbox-style checkbox-round"></div>
                    </label>
                    <div
                        class="switch-tooltip-container"
                        @mouseover="showTooltip = true"
                        @mouseleave="showTooltip = false"
                        @click="toggleTooltip"
                    >
                        <i class="fas fa-info-circle"></i>
                        <div v-if="showTooltip" class="switch-tooltip">
                            {{ $t('marketing.campaigns.security_tip') }}
                        </div>
                    </div>
                </span>
            </div>
        </div>

        <modal
            name="fullscreen-modal-export-html-send-test"
            width="80%"
            height="90%"
            :adaptive="false"
            :scrollable="true"
            :draggable="false"
            :click-to-close="true"
        >
            <button class="btn-close btn-exit" @click="$modal.hide('fullscreen-modal-export-html-send-test')"></button>
            <div class="row justify-content-center mt-33px">
                <div class="col-12 pb-5">
                    <div class="row justify-content-center align-items-center">
                        <div class="col-4">
                            <input
                                class="form-control w-100"
                                :placeholder="$t('marketing.campaigns.test_email_placeholder')"
                                type="email"
                                v-model="modelForTest.email"
                            />
                        </div>
                        <div class="col-3">
                            <input
                                class="form-control w-100"
                                type="text"
                                :placeholder="$t('marketing.campaigns.test_subject_placeholder')"
                                v-model="modelForTest.object"
                            />
                        </div>
                        <div class="col-2">
                            <button
                                class="btn btn-primary btn-plr-15 fs-xs fw-medium rounded-8 h-45"
                                style="
                                    cursor: pointer;
                                    display: flow;
                                    width: 100%;
                                    height: 50px !important;
                                    font-size: 0.9em !important;
                                "
                                :disabled="isDisabledBtnSendEmailTest"
                                @click="sendEmailForTest"
                            >
                                <span v-if="isLoadingSendTestBtn">
                                    <i class="fa fa-spinner fa-spin fa-fw"></i> {{ $t('common.loading') }}
                                    <span class="sr-only"> {{ $t('common.loading') }}</span>
                                </span>
                                <span v-else>
                                    <i class="fas fa-check" :title="$t('marketing.campaigns.send_test')"></i>
                                    {{ $t('marketing.campaigns.send_test') }}</span
                                >
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="email-content">
                <div v-html="model.content" :style="{ width: '100%', overflow: 'auto', boxSizing: 'border-box' }"></div>
            </div>
        </modal>

        <modal
            name="fullscreen-modal-customer-filters"
            width="80%"
            height="90%"
            :adaptive="false"
            :scrollable="true"
            :draggable="false"
            :click-to-close="true"
        >
            <button class="btn-close btn-exit" @click="closeModelCustomerFilters"></button>
            <div class="modal-customer-filters-content">
                <customer-filters @valide="handleValideCustomerFilters"></customer-filters>
            </div>
        </modal>
    </div>
</template>

<script>
// v-select
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import CustomerFilters from '../Customer/CustomerFilters.vue'
import ApiManager from '../Customer/Api/ApiManagerBoCutomer.js'
import ApiManagerMarketing from './Api/ApiManagerMarketing.js'
import { debounce } from 'lodash'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'

export default {
    name: 'MarketingCompaignEmailsCreate',
    props: ['url_btn_campaigne_email_models', 'url_btn_campaigne_index', 'establishment', 'campaign_uuid'],
    data() {
        return {
            blocks: [{ isOpen: false }, { isOpen: false }, { isOpen: false }, { isOpen: false }, { isOpen: false }],
            model: {
                id: 0,
                uuid: '',
                name: this.$t('marketing.campaigns.untitled'),
                name_sender: '',
                email_sender: '',
                email_subject: '',
                email_subject_preview: '',
                selectedOption: 'send-prog',
                start_date: '',
                start_time: '',
                selectedFilter: '',
                exclude_emails: [],
                confirmed: false,
                status: 0,
                status_name: this.$t('marketing.campaigns.status.draft'),
                security_user_received_last_hour_is_active: true,
            },
            modelForTest: {
                object: '',
                email: '',
            },
            applyedFiltersList: [],
            search: '',
            offset: 1,
            limit: 100,
            total: 0,
            to: 0,
            customers: [],
            loading: false,
            editMode: false,
            isLoadingSendBtn: false,
            isLoadingSaveBtn: false,
            isLoadingSendTestBtn: false,
            showTooltip: false,
        }
    },
    computed: {
        filtered() {
            return this.customers.filter((row) => row.email.toLocaleLowerCase().includes(this.search.toLocaleLowerCase()))
        },
        hasNextPage() {
            return this.to < this.total
        },
        excludedUsersEmails() {
            return this.model?.exclude_emails.map((row) => row.email)
        },
        getUsersIdForexcludedEmails() {
            return this.model?.exclude_emails.map((row) => row.id)
        },
        shouldDisplayButtonFinishLater() {
            return ['', 0, 4].includes(this.model.status)
        },
        isValideStep2() {
            return this.model.name_sender === '' || this.model.email_sender === '' || !this.isEmailValid(this.model?.email_sender)
        },
        isDisabledBtnSendEmailTest() {
            const modelTest = this.modelForTest
            return (
                !this.isEmailValid(modelTest.email) ||
                this.model.content == '' ||
                this.model.content == null ||
                modelTest.object == '' ||
                modelTest.object == null
            )
        },
    },
    methods: {
        sleep(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms))
        },
        isEmailValid(email) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return emailPattern.test(email)
        },

        toggle(index) {
            this.blocks[index].isOpen = !this.blocks[index].isOpen
        },

        toggleCheckbox() {
            this.model.security_user_received_last_hour_is_active = !this.model.security_user_received_last_hour_is_active
        },

        toggleTooltip() {
            this.showTooltip = !this.showTooltip
        },

        save(index) {
            this.toggle(index)
            if (!this.blocks[index].isOpen && this.shouldDisplayButtonFinishLater) {
                this.campaigneEmailstore()
            }
        },

        selectOption(option) {
            this.model.selectedOption = option
            if (option == 'send-now') {
                this.model.start_date = null
                this.model.start_time = null
            }
            this.$forceUpdate()
        },

        setSelectedFilter(value) {
            this.$forceUpdate()
        },

        isDefined(value) {
            return value !== undefined && value !== null && value !== ''
        },

        isStepValid(index) {
            switch (index) {
                case 0:
                    return this.isDefined(this.model.selectedFilter)
                case 1:
                    return !(
                        this.model.name_sender === '' ||
                        this.model.email_sender === '' ||
                        !this.isEmailValid(this.model?.email_sender)
                    )
                case 2:
                    return this.isDefined(this.model.email_subject)
                case 3:
                    return (
                        this.model.selectedOption === 'send-now' ||
                        (this.model.selectedOption === 'send-prog' &&
                            this.isDefined(this.model.start_date) &&
                            this.isDefined(this.model.start_time))
                    )
                case 4:
                    return this.isDefined(this.model.content)
                default:
                    return false
            }
        },

        enter(el) {
            el.style.height = '0'
            el.style.transition = 'height 0.15s ease'
            requestAnimationFrame(() => {
                el.style.height = el.scrollHeight + 'px'
            })
        },

        leave(el) {
            el.style.height = el.scrollHeight + 'px'
            el.style.transition = 'height 0.15s ease'
            requestAnimationFrame(() => {
                // el.style.height = '0';
            })
        },

        notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0))
        },

        notBeforeTodayTwelveOClock(date) {
            return date < new Date(new Date().setHours(12, 0, 0, 0))
        },

        async fetchApplyFilters(params) {
            this.isLoadingSendBtn = true
            try {
                const result = await ApiManager.fetchApplyFilters(params)
                this.applyedFiltersList = result?.userCustomFilter ?? []
                this.to = result?.customers.to ?? 0
                this.total = result?.customers.total ?? 0
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.isLoadingSendBtn = false
            }
        },

        async onSearchCustomer(params, loading = null) {
            try {
                const result = await ApiManager.fetchCustomers(params)
                this.customers = result?.data ?? []
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                if (loading) {
                    loading(false)
                }
            }
        },

        onSearch(query, loading) {
            if (query.length > 2) {
                loading(true)
                this.debouncedFetchCustomers(loading, query, this)
            } else {
                this.customers = []
            }
        },

        debouncedFetchCustomers: debounce(function (loading, query, vm) {
            this.onSearchCustomer(
                {
                    ajax: true,
                    page: 1,
                    perPage: 15,
                    columns: ['id', 'first_name', 'last_name', 'email'],
                    search: query,
                },
                loading
            )
        }, 300),

        async onOpen() {
            if (!this.hasNextPage) return

            this.$nextTick(() => {
                const dropdownMenu = document.querySelector('.vs__dropdown-menu')
                if (dropdownMenu) {
                    dropdownMenu.addEventListener('scroll', this.onScroll)
                }
            })
        },

        onClose() {
            // this.observer.disconnect()
        },

        remove() {
            this.model.exclude_emails = []
        },

        onScroll(event) {
            const { scrollTop, clientHeight, scrollHeight } = event.target
            if (scrollTop + clientHeight >= scrollHeight - 10 && this.hasNextPage) {
                this.offset += 1
                this.fetchApplyFilters({
                    getCustomersEmails: false,
                    perPage: this.limit,
                    page: this.offset,
                })
            }
        },

        goToModels() {
            window.location.href = this.url_btn_campaigne_email_models + '?campaigne_email_uuid=' + this.model?.uuid
        },

        goIndexCampaign() {
            window.location.href = this.url_btn_campaigne_index
        },

        /**
         * Function to format a date to 'YYYY-MM-DD'
         * @param {Date} date - The date object to format.
         * @returns {string} The formatted date string.
         */
        formatDate(date) {
            const d = new Date(date)
            let month = '' + (d.getMonth() + 1)
            let day = '' + d.getDate()
            const year = d.getFullYear()

            if (month.length < 2) month = '0' + month
            if (day.length < 2) day = '0' + day

            return [year, month, day].join('-')
        },

        /**
         * Extracts time from a datetime string.
         * @param {string} datetime - The datetime string to extract time from.
         * @returns {string|null} The extracted time (HH:mm:ss) or null if datetime is invalid.
         */
        extractTime(datetime) {
            if (!datetime) return null // Return null if datetime is not provided

            const startTimeDate = new Date(datetime)
            if (isNaN(startTimeDate.getTime())) return null // Return null if datetime is invalid

            const hours = startTimeDate.getHours().toString().padStart(2, '0')
            const minutes = startTimeDate.getMinutes().toString().padStart(2, '0')
            const seconds = startTimeDate.getSeconds().toString().padStart(2, '0')

            return `${hours}:${minutes}:${seconds}`
        },

        async campaigneEmailstore(isEnd = '') {
            this.isLoadingSaveBtn = true
            let _model = cloneDeep(this.model)

            _model.user_custom_filter_id = this.model?.selectedFilter?.id
            _model.exclude_emails = this.excludedUsersEmails
            _model.excludedEmailsUsersIds = this.getUsersIdForexcludedEmails
            _model.start_date = this.model.start_date ? this.formatDate(this.model.start_date) : null
            _model.start_time = this.extractTime(this.model.start_time)

            try {
                const res = await ApiManagerMarketing.campaigneEmailsStore(_model)
                this.model.uuid = res?.data.data?.uuid
                this.model.id = res?.data.data?.id
                if (res.status == 200) {
                    this.notifySuccess(res?.data?.message ?? this.$t('marketing.messages.saved_success'))
                    if (isEnd == 'end') this.goIndexCampaign()
                } else {
                    this.notifyError(res?.message)
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //this.showErrorMessages(error.response.data.errors)
            } finally {
                this.isLoadingSaveBtn = false
            }
        },

        openEditMode() {
            this.editMode = !this.editMode

            if (!this.editMode) {
                this.campaigneEmailstore()
            }
        },

        async getCampaignByUuid(uuid) {
            if (!uuid || uuid == '') return
            this.isLoadingSendBtn = true
            const params = { ajax: true }
            try {
                const result = await ApiManagerMarketing.campaigneShow(uuid, params)
                this.setContent(result?.data ?? [])
            } catch (error) {
                this.$toast.error(error.response.data.message)
            } finally {
                this.isLoadingSendBtn = false
            }
        },

        setContent(data) {
            this.model = data
            this.model.selectedFilter = this.applyedFiltersList.find((i) => i.id == data?.user_custom_filter_id ?? 0)

            if (data.start_date == null && data.start_time == null) {
                this.model.selectedOption = 'send-now'
            } else {
                const formatToDate = moment(`${data.start_date} ${data.start_time}`).toDate()
                this.model.start_date = formatToDate
                this.model.start_time = formatToDate
                this.model.selectedOption = 'send-prog'
            }
        },

        async send() {
            this.isLoadingSendBtn = true
            try {
                const result = await ApiManagerMarketing.send(this.model.uuid, this.model)

                if (result.success) {
                    this.notifySuccess(result?.message ?? this.$t('marketing.messages.sending_started'))
                    await this.sleep(800)
                    this.goIndexCampaign()
                } else {
                    this.notifyError(result?.message)
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //this.notifyError(error?.response?.data?.message)
            } finally {
                this.isLoadingSendBtn = false
            }
        },

        showErrorMessages(errors) {
            if (errors) {
                for (const [key, messages] of Object.entries(errors)) {
                    messages.forEach((message) => this.notifyError(message))
                }
            } else {
                this.notifyError(message || this.$t('common.error_occurred'))
            }
        },

        notifyError(message = this.$t('common.error_occurred')) {
            this.$toast.error(message)
        },

        notifySuccess(message = this.$t('marketing.messages.operation_success'), timeout = 3000) {
            this.$toast.success(message)
        },

        async sendEmailForTest() {
            this.isLoadingSendTestBtn = true
            try {
                const result = await ApiManagerMarketing.sendEmailForTest(this.model.uuid, this.modelForTest)

                if (result.success) {
                    this.notifySuccess(result?.message ?? this.$t('marketing.messages.test_sending_started'))
                    this.modelForTest.email = ''
                    this.modelForTest.object = ''
                    this.$modal.hide('fullscreen-modal-export-html-send-test')
                } else {
                    this.notifyError(result?.message)
                }
            } catch (error) {
                this.$toast.error(error.response.data.message)
                //this.notifyError(error)
            } finally {
                this.isLoadingSendTestBtn = false
            }
        },

        async handleDuplication() {
            this.model.id = 0
            this.model.uuid = ''
            this.model.name = this.$t('marketing.campaigns.actions.duplicate') + ' : ' + this.model.name
            this.model.confirmed = false
            this.model.status = 0
            this.campaigneEmailstore()
        },

        exportHtmlAndOpenModal() {
            this.$modal.show('fullscreen-modal-export-html-send-test')
        },

        openModalCustomerFilters() {
            this.$modal.show('fullscreen-modal-customer-filters')
        },

        closeModelCustomerFilters() {
            this.$modal.hide('fullscreen-modal-customer-filters')
        },

        async handleValideCustomerFilters() {
            this.closeModelCustomerFilters()

            await this.fetchApplyFilters({
                getCustomersEmails: false,
                perPage: this.limit,
                page: this.offset,
            })
        },
    },

    async mounted() {
        await this.fetchApplyFilters({
            getCustomersEmails: false,
            perPage: this.limit,
            page: this.offset,
        })

        const uuid = new URLSearchParams(window.location.search).get('campaigne_email_uuid') || this.campaign_uuid
        const is_duplication = new URLSearchParams(window.location.search).get('is_duplication') || false
        await this.getCampaignByUuid(uuid)

        if (is_duplication) {
            await this.handleDuplication()
        }

        this.onSearchCustomer({
            ajax: true,
            page: 1,
            perPage: 15,
            columns: ['id', 'first_name', 'last_name', 'email'],
        })

        this.model.name_sender = this.establishment?.name
        this.model.email_sender = this.establishment?.email
    },
    components: {
        'customer-filters': CustomerFilters,
        vSelect,
    },
}
</script>

<style scoped>
.text-muted {
    color: #94a3b8 !important;
}

.collaps {
    background-color: #fff;
    border-radius: 20px;
    border: 1px solid rgba(123, 130, 137, 0.3);
    box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.05);
    padding: 1rem 2rem;
    margin-top: 15px;
}

.collaps-subtitle {
    margin: 0;
    font-weight: 500;
}

.collaps-description {
    margin-bottom: 0 !important;
}

.btn-plr-15 {
    padding: 0 1rem !important;
}

.btn-primary {
    width: 200px;
    height: 40px !important;
    border-radius: 12px !important;
}

.btn-primary-inverse {
    height: 40px !important;
    border-radius: 12px !important;
    padding: 0.5rem 1rem !important;
}

.btn-primary-inverse:disabled {
    color: #fff;
}

.btn-primary-icon {
    color: #fff !important;
    background-color: #7d2dbd;
    border-color: #7d2dbd;
    height: 50px !important;
    line-height: 35px;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.icon {
    text-align: center;
    font-size: 2rem;
    padding: 0;
}

.icon .fa {
    margin-top: 15px;
}

.icon .default {
    color: #ccc;
}

.icon .fa-success {
    color: #22bb33;
}

.text-muted {
    color: #7b8289;
}

.float-right {
    float: right;
}

label {
    font-weight: normal !important;
}

input {
    border-radius: 12px !important;
}

.radio-container {
    color: white;
    cursor: pointer;
    padding: 0.2rem;
    padding-top: 1.5rem;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
}

.selected-container {
    background-color: rgba(98, 194, 246, 0.08);
    border: 1px solid rgba(98, 194, 246, 1);
}

/* Hide the default radio button */
.custom-radio {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom radio button */
.custom-radio + label {
    position: relative;
    padding-left: 50px;
    cursor: pointer;
    display: inline-block;
    color: black; /* Default label color */
}

.radio-description {
    padding-left: 50px;
    font-size: 0.8rem;
    cursor: pointer;
}

.custom-radio + label::before {
    content: '';
    position: absolute;
    left: 10px;
    top: 50%;
    width: 20px;
    height: 20px;
    border: 2px solid rgba(98, 194, 246, 1);
    border-radius: 50%;
    background-color: white;
}

/* Custom radio button checked state */
.custom-radio:checked + label::before {
    background-color: rgba(98, 194, 246, 1);
}

.custom-radio:checked + label {
    color: rgba(98, 194, 246, 1); /* Label color when selected */
}

.mx-input {
    border-radius: 5px !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}

.compaine-img-block {
    margin-top: 1rem;
    width: 100%;
    max-height: 500px;
}

.pagination {
    display: flex;
    margin: 0.25rem 0.25rem 0;
}
.pagination button {
    flex-grow: 1;
}
.pagination button:hover {
    cursor: pointer;
}

#exclude_emails .vs__dropdown-menu {
    height: 350px;
}

.campaing-name {
    line-height: 22px;
    font-weight: 500;
    margin-bottom: 10px;
}

.loader-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}

.loader-overlay::before {
    content: '';
    width: 3rem;
    height: 3rem;
    border: 0.3rem solid #f3f3f3;
    border-top: 0.3rem solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.email-content {
    height: calc(100% - 120px);
    overflow-y: auto;
}

.modal-customer-filters-content {
    height: calc(100% - 120px);
    overflow-y: auto;
    padding: 2rem;
}

.btn-exit {
    position: absolute;
    top: 10px;
    right: 10px;
}

.btn-send {
    position: absolute;
    bottom: 41px;
    right: 29px;
}

.vm--modal {
    background-color: #ebe5dd;
}

.campaign-email-switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
}

.campaign-email-switch input {
    display: none;
}

.checkbox-style {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.checkbox-style:before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked + .checkbox-style {
    background-color: #3498db;
}

input:focus + .checkbox-style {
    box-shadow: 0 0 1px #3498db;
}

input:checked + .checkbox-style:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

.checkbox-style.checkbox-round {
    border-radius: 34px;
}

.checkbox-style.checkbox-round:before {
    border-radius: 50%;
}

.switch-container {
    display: inline-block;
}

.input-with-icon {
    display: inline-block;
    position: relative;
    display: flex;
    align-items: center;
}

.switch-tooltip-container {
    margin-left: 10px;
    cursor: pointer;
    position: relative;
}

.switch-tooltip {
    position: absolute;
    top: 25px;
    left: 0;
    background-color: #333;
    color: #fff;
    padding: 5px 10px;
    border-radius: 4px;
    white-space: nowrap;
}
</style>
